import axios from 'axios';
import { auth, resError } from '@services/Helpers/ServiceInterceptor';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/ApplicationAdvance/',
});

api.interceptors.request.use((config) => auth(config));
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => resError(error)
);

class ApplicationAdvanceService {
  constructor() {
    if (!ApplicationAdvanceService.instance) {
      ApplicationAdvanceService.instance = this;
    }
    return ApplicationAdvanceService.instance;
  }

  search = (filters, orderBy, orderDir, p, fields, perPage) => {
    return api.post('/search', {
      filters: Object.keys(filters).length > 0 ? filters : null,
      orderBy,
      orderDir,
      page: p,
      fields: undefined,
      perPage: parseInt(perPage),
    });
  };

  create = (entity) => {
    return api.post('/', entity);
  };

  calculateHCV = (entity) => {
    return api.post('/calculateHCV', entity);
  };

  calculateAdvanceFees = (entity) => {
    return api.post('/calculateAdvanceFees', entity);
  };

  read = (id) => {
    return api.get('/' + id);
  };

  update = (entity) => {
    return api.put('/', entity);
  };

  delete = (id) => {
    return api.delete('/' + id);
  };

  autoSuggest = (value) => {
    return api.post('/search', { filters: { displayName: value }, perPage: 20, page: 1 });
  };

  advancestatuses = () => {
    return api.get('/advancestatuses');
  };

}

const instance = new ApplicationAdvanceService();
Object.freeze(instance);

export default instance;
